<template>
  <v-col cols="12" class="text-left">
    <span class="ntitlesdark--text font-weight-medium font-size-2">{{ titleInput }}</span>
  </v-col>
</template>

<script>
export default {
  name: "TitleInput",
  props: {
    titleInput: {
      type: String,
      default: ""
    }
  }
}
</script>

<style scoped>

</style>
